import React from 'react';
import { createRoot } from 'react-dom/client';
import LocationsSelector from './LocationsSelector'

const LocationsSelectorRoot = (props) => {
    return <LocationsSelector {...props} />
}

export default LocationsSelectorRoot;

if(typeof window.locationsSelectorRoots == 'undefined') {
    window.locationsSelectorRoots = {};
}

// MOUNT/UNMOUNT OK
window.LocationsSelectorRoot = function () {
    let allElts = document.querySelectorAll('[data-react="locations-selector"]');
    for (const element of allElts) {
        let attr = { ...LocationsSelectorRoot.defaultProps };
        attr.hotels_id = element.dataset.hotels_id;
        attr.name = element.getAttribute('name');
        element.removeAttribute('name');

        attr.id = element.getAttribute('id');
        element.removeAttribute('id');

        attr.multiple = element.dataset.multiple === 'false' ? false : true;

        attr.displayPax = element.dataset.displayPax;
        if (element.dataset.defaultValue) {
            attr.defaultValue = element.dataset.defaultValue.split(',');
        }

        attr.ajax_load = element.dataset.ajaxLoad === 'false' ? false : true;
        attr.required = element.dataset.required === 'true';
        attr.locations_loaded = JSON.parse(element.dataset.locationsLoaded ?? '[]');

        attr.display_label = element.dataset.display_label === 'true';

        // Traductions
        if (element.dataset.placeholder && element.dataset.placeholder != '') {
            attr.placeholder = element.dataset.placeholder;
        }

        if (element.dataset.label && element.dataset.label != '') {
            attr.label = element.dataset.label;
        }

        if (element.dataset.label_btn_associer && element.dataset.label_btn_associer != '') {
            attr.label_btn_associer = element.dataset.label_btn_associer;
        }
        
        if (element.dataset.windowId && element.dataset.windowId != '') {
            attr.windowId = element.dataset.windowId;
        }

        createRoot(element).render(<LocationsSelectorRoot {...attr} />);
    }
}